module.exports = __webpack_public_path__ + "stadtmodel.b6425c.png";